/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Template } from '../../models/template';

export interface GetTemplateById$Json$Params {

/**
 * template name
 */
  name?: string;

/**
 * template id
 */
  id: string;
}

export function getTemplateById$Json(http: HttpClient, rootUrl: string, params: GetTemplateById$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Template>> {
  const rb = new RequestBuilder(rootUrl, getTemplateById$Json.PATH, 'get');
  if (params) {
    rb.query('name', params.name, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Template>;
    })
  );
}

getTemplateById$Json.PATH = '/api/Template/{id}';
